// src/api/comments.ts
import axios from './axiosConfig';

const base = '/api/comments';

export interface Comment {
    id: string;
    revision_group_id: string; // ✅ renamed to match backend
    user_id: number;
    user_email: string;
    content: string;
    parent_id: string | null;
    created_at: string;
    updated_at: string;
    is_deleted: boolean;
    replies?: Comment[]; // optional for nesting
}

export const fetchComments = async (
    revisionGroupId: string
): Promise<Comment[]> => {
    const response = await axios.get(`${base}/group/${revisionGroupId}`);
    return response.data;
};

export const postComment = async (
    revisionGroupId: string,
    content: string,
    parentId: string | null = null
): Promise<Comment> => {
    const response = await axios.post(`${base}/`, {
        revision_group_id: revisionGroupId, // ✅ updated key name
        content,
        parent_id: parentId,
    });
    return response.data;
};

export const updateComment = async (
    commentId: string,
    content: string
): Promise<Comment> => {
    const response = await axios.patch(`${base}/${commentId}`, {
        content,
    });
    return response.data;
};

export const deleteComment = async (commentId: string): Promise<Comment> => {
    const response = await axios.delete(`${base}/${commentId}`);
    return response.data;
};
